import React from "react";

export const Hourglass = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18H14" stroke="#071621" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.979 3H7.021C6.469 3 6.021 3.448 6.021 4V6.378C6.021 6.799 6.154 7.21 6.401 7.551L9.621 12L6.401 16.449C6.154 16.79 6.021 17.201 6.021 17.622V20C6.021 20.552 6.469 21 7.021 21H16.978C17.53 21 17.978 20.552 17.978 20V17.658C17.978 17.214 17.83 16.783 17.558 16.432L14.121 12L17.559 7.567C17.831 7.216 17.979 6.785 17.979 6.341V4C17.979 3.448 17.531 3 16.979 3Z" stroke="#071621" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
